export default "__VITE_ASSET__daa53983__"